<app-title-bar [title]='"Galeria de Mapas base"' [icon]="'dataset'"></app-title-bar>
<div id="divBasemapGallery" class="BasemapGallery">
</div>